import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AlertNotificationService } from 'src/app/services/alert-notification.service';
import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import { ProjectFinanceAttachment } from 'src/app/models/entities/project-finance';

@Component({
  selector: 'projects-finance-attachment',
  templateUrl: './projects-finance-attachment.component.html',
  styleUrl: './projects-finance-attachment.component.scss'
})
export class ProjectsFinanceAttachmentComponent {
  @Input() label: string = 'Attachment';
  @Input() attachment: ProjectFinanceAttachment | null = null;
  @Input() pendingFile: File | null = null;
  @Input() accept: string = '';
  @Input() emptyText: string = 'No attachment yet';
  @Input() readonlyAttachmentsPanel: boolean = false;
  @Input() validateFile?: (file: File) => string | null;

  @Output() pendingFileChange = new EventEmitter<File | null>();
  @Output() download = new EventEmitter<ProjectFinanceAttachment>();

  constructor(
    private alertNotificationService: AlertNotificationService,
    private confirmationDialogService: ConfirmationDialogService
  ) { }

  get hasContent(): boolean {
    return !!this.attachment || !!this.pendingFile;
  }

  get canAddFile(): boolean {
    return !this.readonlyAttachmentsPanel;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file) return;

    const validationError = this.validateFile?.(file) ?? null;
    if (validationError) {
      this.alertNotificationService.warning(validationError);
      return;
    }
    this.pendingFileChange.emit(file);
  }

  downloadFile(attachment: ProjectFinanceAttachment): void {
    this.download.emit(attachment);
  }

  confirmRemovePendingFile(): void {
    if (!this.pendingFile) return;
    this.confirmationDialogService.open(
      `Are you confident in your decision to remove ${this.pendingFile.name}?`,
      () => this.pendingFileChange.emit(null)
    );
  }
}
